module.exports = __webpack_public_path__ + "static/media/telegram.9522f6ff.svg";